<template>
    <div
        class="box-modal fade"
        tabindex="-1"
        data-element="modal-tariff-select"
    >
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close ui ui-cross" @click="close"></button>
            </div>
            <div class="modal-body">
                <p>
                    Платить по выбранным тарифам вы будете в компанию {{ provider.name }}.
                </p>
                <div class="fmc-provider">
                    <div class="row-inline">
                        <div
                            class="col-md-4 fmc-provider-logo mb-2"
                            v-if="provider.logo"
                        >
                            <img
                                :src="provider.logo"
                                :alt="'Тарифы на номера предоставлены ' + provider.name"
                            />
                        </div>
                        <div class="col-12" :class="[provider.logo ? 'col-md-8' : 'col-md-12']">
                            <ul class="nums-tariff-list" v-if="tariffs">
                                <li
                                    class="form-group"
                                    :key="tariff.id"
                                    v-for="tariff in tariffs"
                                >
                                    <input
                                        type="radio"
                                        data-element="tariff-item"
                                        :id="'tariff_select_' + tariff.id"
                                        :value="tariff.id"
                                        v-model="selectedTariffId"
                                    />
                                    <label
                                        :for="'tariff_select_' + tariff.id"
                                        class="block"
                                    >
                                      <span
                                          :data-element="'tariff_select_name_' + tariff.id"
                                      >{{ tariff.name }}</span>
                                        <template v-if="tariff.description">
                                            <br />
                                            <span
                                                :data-element="'tariff_select_price_' + tariff.id"
                                                class="price-tariff"
                                            >{{ tariff.description }}</span>
                                        </template>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="t-center mt-4">
                        <Button
                            size="md"
                            title="Выбрать тариф"
                            @click="submit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '../../../components/ui/Button.vue';
import ModelProvider from '../models/provider.js';
import ModelTariff from '../models/tariff.js';
import message from '../../../lib/message.js'


export default {
    name: "SelectTariffModal",
    components: {
        Button
    },
    props: {
        provider: {
            type: ModelProvider
        },
        tariffs: {
            type: Array
        },
        selectedTariff: {
            type: ModelTariff
        },
        selectTariffFunction: {
            type: Function
        }
    },
    data () {
        return {
            selectedTariffId: null
        }
    },
    computed: {
        selectedId () {
            let grouped = {};
            if (Array.isArray(this.selectedBranches)) {
                this.selectedBranches.forEach(branch => {
                    grouped[branch.id] = true;
                })
            }
            return grouped;
        },
        displayBranches () {
            let branches = this.branches;
            if (Array.isArray(branches)) {
                return branches.filter(branch => !this.selectedId[branch.id])
            }
            return [];
        },
        filteredBranches () {
            if (this.query) {
                let regexp = new RegExp(this.query, 'i');
                return this.displayBranches.filter(branch => regexp.test(branch.name))
            }
            return this.displayBranches;
        }
    },
    mounted () {
        if (this.selectedTariff) {
            this.selectedTariffId = this.selectedTariff.id
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        submit () {
            let tariff = this.tariffs.find(tariff => tariff.id === this.selectedTariffId);
            if (!tariff) {
                message.showError('Выберите тариф');
                return;
            }

            if (this.selectedTariff && this.selectedTariff.id === tariff.id) {
                this.close();
                return;
            }
            this.close();
            setTimeout(this.selectTariffFunction(tariff), 1000);
        }
    }
}
</script>

<style lang="scss">
    .fmc-provider {

        label span.price-tariff {
            font-size: 0.8rem;
            color: #999;
        }
    }
</style>